import { TextField, IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import FilterStack from './FilterStack';
import FilterToggle from './FilterToggle';
import classes from './classes.module.scss';

import useFilter, {
  TEXT,
  CONTAINS,
  EQUALS,
  NOT_EQUAL,
  NOT_CONTAINS
} from 'app/hooks/useFilter';

// filter class (doesn't change)
const FILTER_CLASS = TEXT;

// enabled filter types
const FILTER_TYPES = [
  CONTAINS,
  EQUALS,
  NOT_EQUAL,
  NOT_CONTAINS
]

// default filter type for new filters in stack
const DEFAULT_FILTER_TYPE = FILTER_TYPES[0];

const TextFilterStack = props => {
  return (
    <FilterStack
      {...props}
      FilterComponent={TextFilter}
      filterClass={FILTER_CLASS}
      defaultFilterType={DEFAULT_FILTER_TYPE}
    />
  );
}

const TextFilter = props => {
  const valueFormatter = event => event.target.value;

  const {
    value,
    onChange,
    filterType,
    setFilterType,
    clearValue
  } = useFilter({
    ...props,
    filterClass: FILTER_CLASS,
    filterType: DEFAULT_FILTER_TYPE,
    valueFormatter
  });

  const filterToggle = <FilterToggle filterType={filterType} filterTypes={FILTER_TYPES} setFilterType={setFilterType} />;

  let clearIcon = null;
  if (value) {
    clearIcon = (
      <InputAdornment position="end">
        <IconButton className={classes.filterIconButton} onClick={clearValue}>
          <CloseIcon className={classes.filterIcon} />
        </IconButton>
      </InputAdornment>
    )
  }

  let sx = {
    height: '100%'
  }
  if (props.sx) {
    sx = { ...sx, ...props.sx };
  }

  const inputProps = {
    startAdornment: filterToggle,
    endAdornment: clearIcon,
    disableUnderline: true,
    sx: {
      height: '2.5rem !important',
      padding: '0 0.5rem',
      borderRadius: '2px !important'
    }
  }

  if (!props.darkMode) {
    inputProps.sx.backgroundColor = '#fff !important';
  }

  return (
    <TextField
      variant="filled"
      size="small"
      sx={sx}
      onChange={onChange}
      InputProps={inputProps}
      defaultValue={value}
    />
  );
}

export default TextFilterStack;
